import React from 'react';
import { BookOpenIcon, GiftIcon, LayersIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  label: '9 comprehensive volumes'
}, {
  icon: GiftIcon,
  label: '5 exclusive bonuses'
}, {
  icon: LayersIcon,
  label: '+450 ready-to-use resources'
}, {
  icon: UsersIcon,
  label: 'Teachers, students and educators'
}];
export function SocialProof() {
  return <section className="border-y border-lava/30 bg-petrol py-5" aria-label="What the teacher ready includes" data-id="element-239" data-mp="3f4w0k0myvke">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-snow sm:justify-between" data-id="element-240" data-mp="8ehfcusatki8">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-241" data-mp="3usr26zgkykgw">
            <Icon className="h-5 w-5 text-lava" aria-hidden="true" data-id="element-242" data-mp="mdpght80v2p2" /> {label}
          </span>)}
      </div>
    </section>;
}